<template>
  <div class="">
    <!-- Filters -->
    <b-form-group :id="`user-table-filter-${_uid}`"
                  label="Filtre par profil :"
                  :label-for="`user-table-filter-roles-${_uid}`"
                  horizontal>

      <b-form-select v-model="roleSelected" class="mb-3" :id="`user-table-filter-roles-${_uid}`">
        <option :value="null">Tous</option>
        <option v-for="(role, index) in getRolesEnumeration()" :value="role.value" :key="index">{{ role.text }}</option>
      </b-form-select>
    </b-form-group>

    <!-- User Table -->
      <b-table
        responsive
        :items="agents"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
        v-show="ready">

      <!-- email -->
      <template slot="HEAD_email" slot-scope="data">
        {{  data.label }}
      </template>
      <template slot="email" slot-scope="row">
        {{  row.item.email }}
      </template>

      <!-- name -->
      <template slot="HEAD_name" slot-scope="data">
        {{  data.label }}
      </template>
      <template slot="name" slot-scope="row">
          {{ getFullName(row.item) }}
      </template>

      <!-- roles -->
      <template slot="HEAD_roles" slot-scope="data">
        {{  data.label }}
      </template>
      <template slot="roles" slot-scope="row">
        <div v-for="(role, index) in row.item.roles" :key="index">
          <!--<icon name="user-circle" scale="1" />-->
          <span>{{ row.item._embedded.roles_enumeration[role] }}</span>
        </div>
      </template>

      <!-- isactive -->
      <template slot="isActive" slot-scope="row">
        <icon name="check" scale="1" v-if="row.item.isActive"/>
        <icon name="times" scale="1" v-else/>
      </template>

      <!-- show -->
      <template slot="show" slot-scope="row">
        <ShowUserProfileButton :user="row.item" @updateUsersTable="updateUsers"/>
      </template>

    </b-table>

    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      aria-controls="my-table"
      v-show="ready">
        <template slot="first-text" slot-scope="item">
          <span class="first-link" :class="item.disabled ? 'disabled' : ''">«</span>
        </template>
        <template slot="prev-text" slot-scope="item">
          <span class="prev-link" :class="item.disabled ? 'disabled' : ''">‹</span>
        </template>
        <template slot="page" slot-scope="item">
          <span class="page" :class="item.active ? 'active' : ''">{{ item.page }}</span>
        </template>
        <template slot="next-text" slot-scope="item">
          <span class="next-link" :class="item.disabled ? 'disabled' : ''">›</span>
        </template>
        <template slot="last-text" slot-scope="item">
          <span class="last-link" :class="item.disabled ? 'disabled' : ''">»</span>
        </template>
        <template slot="ellipsis-text">
          <span class="ellipsis">...</span>
        </template></b-pagination>
  </div>
</template>

<script>
import Clone from 'clone';

import { mapGetters } from 'vuex';
import EnumerationService from '../../services/EnumerationService';

export default {
  name: 'UserTable',
  data() {
    return {
      roleSelected: null,
      enedisCases: null,
      perPage: 10,
      currentPage: 1,
      ready: false,
      agents: [],
    };
  },
  computed: {
    users() {
      let users = [];
      users = Clone(this.getUsers());
      if (users === null
        || typeof users === 'undefined') {
        return;
      }
      if (this.roleSelected !== null) {
        users = users.filter(u => u.roles.indexOf(this.roleSelected) !== -1);
      }

      return users;
    },
    /**
     * When the viewport's size change, the table needs to be responsive
     * So let delete some fields, those which are less important
     *
     * @returns {{username: string, email: string, name: string, roles: string,
     * isActive: {label: string, sortable: boolean},
     * isEmailConfirmed: {label: string, sortable: boolean}, show: string}}
     */
    fields() {
      // Get the viewport type (xs,sm,md,lg,xl)
      const viewPortSize = this.getViewPortSize();
      // Fields table
      const computedFields = {
        email: 'Email',
        name: 'Nom',
        roles: 'Profil',
        isActive: {
          label: 'Actif',
          sortable: true,
        },
        show: 'Détails',
      };
      // According to the size, some fields are deleted to make the table responsive
      if (viewPortSize === 'sm' || viewPortSize === 'xs') {
        delete computedFields.email;
        delete computedFields.name;
        delete computedFields.roles;
        delete computedFields.scoreA;
        delete computedFields.scoreM;
        delete computedFields.scoreS;
        delete computedFields.scoreOnGoing;
      } else if (viewPortSize === 'md') {
        delete computedFields.email;
        delete computedFields.name;
      } if (viewPortSize === 'lg') {
        delete computedFields.email;
      }
      return computedFields;
    },
    rows() {
      return this.agents.length;
    }
  },
  methods: {
    ...mapGetters([
      'getUsers',
      'getRolesEnumeration',
      'getViewPortSize',
      'getTrancheStatusEnumeration',
      'isAdmin',
      'isAgent',
    ]),
    statusArchived() {
      return {
        tranche: this.getTrancheStatusEnumeration().filter(s => s.value === 'STATUS_ARCHIVED')[0].text,
      };
    },
    getFullName(item) {
      return `${item.firstName} ${item.lastName}`.replace(/null/g, 'NR');
    },
    updateUsers(users) {
      this.agents = users;
    },
    addUser(user) {
      this.agents.push(user);
    }
  },
  mounted() {
    // Access check
    if (!this.isAdmin()) {
      this.$router.push({ name: 'dashboard' });
    }

    this.$store.dispatch('getUsers')
      .then()
      .finally(() => {
        this.$store.commit('setGlobalSpinnerShow', false)
        this.ready = true;
      });
  },
  watch: {
    users(newVal) {
      this.agents = newVal;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/tables/UserTable.vue